import { Pagination, Spin, Icon, Card } from "antd";
import React, { useState } from "react";
import index, { Translate } from "react-translated";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import CustomHeader from "../../../CommonHeader/CustomHeader";

const AdminGrid = (props) => {
  const {
    tableData,
    currentPage,
    setCurrentPage,
    totalPages,
    pageSize,
    onPageChange,
    loading,
    coleDef,
    props_label,
  } = props;

  return (
    <Card type="inner" style={{ background: "#FAFAFA" }}>
      <div>
        <div style={{ display: "flex", alignItems: "center", fontWeight:500,color:"#000000d9" }}>
          <Icon type="folder" style={{ marginRight: 10, color: "#1890ff" }} />
          <Translate text={props_label || "Upcoming Calls"} />
        </div>
        {coleDef.length > 0 &&
        Array.isArray(tableData)  ? (
          <Spin spinning={loading}>
            <CustomAgGridTable
              rowDatas={tableData}
              columnDefss={coleDef}
              //   rowDatas={currentState.data}
              //   columnDefss={coleDef}
              // styles={{ height: "400px", minHeight: "380px" }}
            />
          </Spin>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p>Loading...</p>
          </div>
        )}
        <div
          style={{ float: "right", marginTop: "20px", marginBottom: "20px" }}
        >
          <Pagination
            current={currentPage}
            total={totalPages * pageSize}
            pageSize={pageSize}
            showSizeChanger={false}
            onChange={(page) => onPageChange(page)}
          />
        </div>
      </div>
    </Card>
  );
};

export default AdminGrid;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/shared-charts/AdminGrid.js